const firebaseConfig = {
	apiKey: 'AIzaSyB2CBf-VVpkinaLXfyVo_ikt1SjsDAKnw8',
	authDomain: 'volunteer-network-34555.firebaseapp.com',
	databaseURL: 'https://volunteer-network-34555.firebaseio.com',
	projectId: 'volunteer-network-34555',
	storageBucket: 'volunteer-network-34555.appspot.com',
	messagingSenderId: '820203826647',
	appId: '1:820203826647:web:8006f53f9eb6da892a6f92',
};

export default firebaseConfig;
